import React from "react";
import { useNavigate, useLocation, generatePath } from "react-router-dom";

import NavMenuItem from "./NavMenuItem";

import { Container, ItemWrapper } from "./styles";

type NavMenuItemType = {
  title: string;
  route: string;
  rootRoute: string;
};

type Props = { items: NavMenuItemType[] };

const NavMenu: React.FC<Props> = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getIsSelected = (item: NavMenuItemType) => {
    return location.pathname === item.route;
  };

  const onClick = (item: NavMenuItemType) => () => {
    navigate(generatePath(item.route));
  };

    return (
      <Container>
        {items.map(item => (
          <ItemWrapper key={`key:${item.route}-${item.rootRoute}`}>
            <NavMenuItem
              title={item.title}
              onClick={onClick(item)}
              selected={getIsSelected(item)}
            />
          </ItemWrapper>
        ))}
      </Container>
    );
  };

export default NavMenu;
